module.exports = __webpack_public_path__ + "static/media/light-theme-total-entry.d5db07c0.svg";